import * as React from 'react';
import { connect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { GenericError } from '@cian/peperrors/shared';
import { ILogger } from '@cian/logger';
import { IPuids } from '../../types/adfox';

interface IAdfoxPixelContainerProps {
  puids?: IPuids | null;
  logger: ILogger;
}
export const AdfoxPixel = ({ puids, logger }: IAdfoxPixelContainerProps) => {
  const Adfox = connect(AdFoxTemplates);

  if (!puids) {
    return null;
  }

  const onStubHandle = () => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: 'adfoxStub',
        details: { developerId: puids.puid39 },
      }),
    );
  };

  const onErrorHandle = (event: { type: string }) => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: event.type,
        details: { developerId: puids.puid39 },
      }),
    );
  };

  return (
    <Adfox
      onError={onErrorHandle}
      onStub={onStubHandle}
      params={{ p1: 'cyrbe', p2: 'frfe', ...puids }}
      width="1"
      height="1"
    />
  );
};

export const AdfoxPixelContainer = React.memo(AdfoxPixel);
